import http from '../../../../../../common/utils/http'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import Vue from 'vue';
import { TreeSelect, Grid, GridItem } from 'vant';
import { DOWNLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { Empty } from 'vant';

Vue.use(Empty);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(TreeSelect);
export default {
  data () {
    return {
      active: 0,
      items: [],
      classificationLevel1: '1',
      classificationLevel2: '',
      options: []
    };
  },

  methods: {
    onNavClick (item) {
      this.active = item
      this.change()
    },
    getCommodityClassificationList () {
      http.get(API_BASE_URL + '/api/wxoa/pmall/wxoaPmall/getCommodityClassificationList?classificationLevel=' + 1).then(
        res => {
          this.items = res.data.data.map(item => {
            return {
              text: item.classificationName,
              id: item.id
            }
          })
          this.change()
        }
      )
    },
    async change () {
      const lvl2Categories = (await http.get(API_BASE_URL + '/api/wxoa/pmall/wxoaPmall/getCommodityClassificationList?parentId=' + this.items[this.active].id)).data.data

      for (const item of lvl2Categories) {
        item.secondLvName = item.classificationName
        const responseData = (await this.getThreeLvContent(item.id))
        if (responseData) {
          item.threeLvContent = responseData.map(item => {
            let img = `${DOWNLOAD_FILE}${item.codeToFileIds.icon[0]}?X-Authorization=${localStorage.getItem('token')}`
            return {
              img,
              ...item
            }
          })
        }
      }
      this.options = lvl2Categories
      return lvl2Categories
    },
    getThreeLvContent (id) {
      return http.get(API_BASE_URL + '/api/wxoa/pmall/wxoaPmall/getCommodityClassificationList?parentId=' + id).then(
        res => {
          return res && res.data && res.data.data
        }
      )
    },
    goToDetails (item) {
      this.$router.push({
        path: RoutePathConstants.COMMODITY_CLASS,
        query: {
          id: item.id
        }
      })
    },
  },
  mounted () {
    this.getCommodityClassificationList()
  },
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/views/commodity-list/commodity-list.js